/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCRightIcon64Regular = forwardRef('ArrowCRightIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M21.94 9.94a1.5 1.5 0 0 1 2.12 0l16.758 16.757a7.5 7.5 0 0 1 0 10.606L24.061 54.061a1.5 1.5 0 0 1-2.122-2.122l16.758-16.757a4.5 4.5 0 0 0 0-6.364L21.939 12.061a1.5 1.5 0 0 1 0-2.122Z" })));
});
